import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Input,
  Label,
  Container,
  CardFooter,
  Badge,
  UncontrolledTooltip,
  Col,
  Row,
} from "reactstrap";
import RightPanelCard from "components/CommonComponents/RightPanelCard";
import CommonTable from "components/CommonComponents/ReactTable/Table";
import { DEFAULT_RECORDS_PER_PAGE, STATUS_OPTIONS } from "components/constant";
import Select, { components } from "react-select";
import { fixedWidthCustomStyle } from "constants/CommonConstants";
import { NotificationContext } from "components/CommonComponents/NotificationProvider";
import { showAlert } from "components/CommonComponents/CommonFunctions";
import AdminHeader from "components/Headers/AdminHeader";
const skillList = [
  {
    id: 1,
    skillName: "Cable Jointing",
    status: "ACTIVE",
    createdOn: "2024-01-10",
  },
  {
    id: 2,
    skillName: "Substation Maintenance",
    status: "ACTIVE",
    createdOn: "2024-01-12",
  },
  {
    id: 3,
    skillName: "Electrical Safety",
    status: "INACTIVE",
    createdOn: "2024-01-14",
  },
  {
    id: 4,
    skillName: "Cable Jointing",
    status: "ACTIVE",
    createdOn: "2024-01-16",
  },
  {
    id: 5,
    skillName: "Transformer Testing",
    status: "INACTIVE",
    createdOn: "2024-01-18",
  },
  {
    id: 6,
    skillName: "Electrical Safety",
    status: "ACTIVE",
    createdOn: "2024-01-20",
  },
  {
    id: 7,
    skillName: "Substation Maintenance",
    status: "ACTIVE",
    createdOn: "2024-01-22",
  },
  {
    id: 8,
    skillName: "HT & LT Systems",
    status: "INACTIVE",
    createdOn: "2024-01-24",
  },
  {
    id: 9,
    skillName: "Transformer Testing",
    status: "ACTIVE",
    createdOn: "2024-01-26",
  },
  {
    id: 10,
    skillName: "Substation Maintenance.js",
    status: "ACTIVE",
    createdOn: "2024-01-28",
  },
];

const initialFields = {
  skillName: { value: "", error: "" },
  status: { value: "ACTIVE", error: "" },
};

function Skills() {
  const { notify } = useContext(NotificationContext);
  const [isModalOpen, setIsModalOpen] = useState(null); //"add "edit" "null"
  const [formData, setFormData] = useState(initialFields);

  const [pageNum, setPageNum] = useState(1);
  const [searchState, setSearchState] = useState({
    name: "",
    status: null,
    filterParams: [],
  });

  const openAddModal = () => {
    // e.stopPropagation();
    setIsModalOpen("add");
    setFormData(initialFields);
  };

  const openEditModal = (skill) => {
    setIsModalOpen("edit");
    setFormData({
      skillName: { value: skill.skillName, error: "" },
      status: { value: skill.status, error: "" },
    });
  };

  const closeModal = () => {
    setIsModalOpen(null);
    setFormData({
      ...initialFields,
    });
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
  };

  const toggleStatus = (skill) => {
    const isActive = skill.status === "ACTIVE";
    const newStatus = isActive ? "INACTIVE" : "ACTIVE";

    showAlert({
      title: `Are you sure you want to ${
        isActive ? "inactive" : "activate"
      } this skill?`,
      message: `Skill "${
        skill.skillName
      }" will become ${newStatus.toLowerCase()}.`,
      type: "warning",
      confirmStyle: "default",
      cancelStyle: "secondary",
      confirmText: "Yes",
      cancelText: "Cancel",
      onConfirm: () => {},
    });
  };

  const columns = [
    {
      Header: "Sr. No.",
      accessor: "id",
    },
    { Header: "Skill Name", accessor: "skillName" },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ value }) => (
        <Badge color={value === "ACTIVE" ? "success" : "warning"} pill>
          {value}
        </Badge>
      ),
    },
    {
      Header: "Actions",
      accessor: "actions",
      Cell: ({ row }) => {
        const skill = row.original;
        const id = skill.id;
        const status = skill.status;
        const isActive = status === "ACTIVE";

        return (
          <div className="d-flex justify-content-start align-items-center">
            {/* EDIT */}
            <Button
              size="sm"
              color="link"
              className="p-0"
              onClick={() => openEditModal(skill)}
              id={`edit${id}`}
            >
              <i className="fas fa-edit mr-1 table-action-info" />
              <UncontrolledTooltip delay={0} target={`edit${id}`}>
                Edit
              </UncontrolledTooltip>
            </Button>
            {/* Divider */}
            <span className="mr-1 text-muted">|</span>
            {/* Activate / Deactivate */}
            <Button
              color="link"
              size="sm"
              className="d-flex align-items-center p-0 ml-1"
              id={`status${id}`}
              onClick={(e) => {
                e.stopPropagation();
                toggleStatus(skill);
              }}
            >
              {isActive ? (
                <>
                  <i className="fa-regular fa-circle-xmark table-action-delete mr-1" />
                </>
              ) : (
                <>
                  <i className="fa-regular fa-circle-check table-action-success mr-1" />
                </>
              )}
            </Button>
            <UncontrolledTooltip delay={0} target={`status${id}`}>
              {isActive ? "Inactivate" : "Activate"}
            </UncontrolledTooltip>
          </div>
        );
      },
    },
  ];
  const isDuplicateSkillName = (skillName) => {
    const trimmedName = skillName.trim().toLowerCase();
    //trim the value and convert to lowercase
    return skillList.some((skill) => {
      // while editing, allow same name for editing
      if (
        isModalOpen === "edit" &&
        skill.skillName === formData.skillName.value //compare the value of skillname in list and enter value in form
      ) {
        return false;
      }
      return skill.skillName.trim().toLowerCase() === trimmedName;
    });
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: { value, error: "" },
    }));
  };

  // Custom Option Renderer
  const Option = (props) => {
    return (
      <components.Option {...props}>
        <Badge
          color={props.data.value === "ACTIVE" ? "success" : "warning"}
          pill
        >
          {props.data.label}
        </Badge>
      </components.Option>
    );
  };

  // Custom SingleValue Renderer (for the selected value)
  const SingleValue = (props) => {
    return (
      <components.SingleValue {...props}>
        <Badge
          color={props.data.value === "ACTIVE" ? "success" : "warning"}
          pill
        >
          {props.data.label}
        </Badge>
      </components.SingleValue>
    );
  };

  const handleClear = () => {
    setSearchState({
      query: "",
      status: null,
      filterParams: [],
    });
    if (pageNum !== 1) setPageNum(1);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  const handleSearch = () => {};

  const getValidationError = (name, value) => {
    const trimmedValue = typeof value === "string" ? value.trim() : value;
    switch (name) {
      case "skillName":
        if (!trimmedValue) return "Please enter skill name";
        if (isDuplicateSkillName(trimmedValue))
          return "Skill name already exists";
        return "";

      default:
        return "";
    }
  };

  const validateForm = () => {
    let newSkill = { ...formData };

    Object.keys(newSkill).forEach((key) => {
      newSkill[key] = {
        ...newSkill[key],
        error: getValidationError(key, newSkill[key].value),
      };
    });

    setFormData(newSkill);
    return Object.values(newSkill).every((item) => item.error === "");
  };

  //on blur to get if any validation error exits
  const handleOnBlur = (name, value) => {
    const trimmedValue = typeof value === "string" ? value.trim() : value;
    const error = getValidationError(name, trimmedValue);
    setFormData((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        value: trimmedValue,
        error,
      },
    }));
  };

  return (
    <>
      <AdminHeader />
      <Container fluid className="mt--6">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader className="d-flex align-items-center justify-content-between">
                <CardTitle tag="h3" className="mb-0">
                  Skills
                </CardTitle>

                <Button className="btn-deep-blue" onClick={openAddModal}>
                  <i className="fa fa-plus mr-1" />
                  Skill
                </Button>
              </CardHeader>
              {/* Body */}
              <CardBody>
                <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap flex-column flex-md-row">
                  {/* Left side - Filter Inputs + Search */}
                  <div className="d-flex flex-wrap align-items-center filter-group">
                    <Input
                      type="text"
                      placeholder="Search by skill name"
                      className="mr-2 mb-2 filter-input-large"
                      value={searchState.searchString}
                      onChange={(e) =>
                        setSearchState((prev) => ({
                          ...prev,
                          searchString: e.target.value,
                        }))
                      }
                      onKeyDown={handleKeyDown}
                    />
                    <Select
                      className="mr-2 mb-2 filter-select"
                      options={STATUS_OPTIONS}
                      placeholder="Select Status"
                      classNamePrefix="react-select"
                      styles={fixedWidthCustomStyle()}
                      components={{ Option, SingleValue }}
                    />

                    <Button
                      color="default"
                      // className="d-flex align-items-center btn-deep-blue mb-0"
                      className="d-flex align-items-center mb-2 filter-btn btn-deep-blue"
                      onClick={handleSearch}
                    >
                      <i className="fa fa-search mr-1" />
                      Search
                    </Button>

                    {Object.keys(searchState.filterParams).length > 0 && (
                      <Button
                        color="default"
                        className="ml-2 mb-0 filter-btn btn-simple"
                        onClick={handleClear}
                      >
                        <i className="fa fa-times mr-1" /> Clear
                      </Button>
                    )}
                  </div>
                </div>

                <div className="mt-2 mb-3 mx-1">
                  {skillList.length ? (
                    <span className="total-records">
                      Total Records : {skillList.length}
                    </span>
                  ) : null}
                </div>

                <div className="table-responsive">
                  <CommonTable
                    data={skillList || []}
                    columns={columns}
                    pageNum={pageNum}
                    setPageNum={setPageNum}
                    defaultPageSize={DEFAULT_RECORDS_PER_PAGE}
                    showPaginationBottom
                    totalPages={Math.ceil(
                      skillList.length / DEFAULT_RECORDS_PER_PAGE,
                    )}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <RightPanelCard isOpen={isModalOpen !== null} onClose={closeModal}>
          <Card>
            <CardHeader tag="div" className="p-3">
              <div className="d-flex align-items-center justify-content-between mt-2">
                <div className="d-flex align-items-center">
                  <i
                    className="fa-solid fa-angle-left cursor mr-2"
                    onClick={closeModal}
                  ></i>
                  <h4 className="mb-0">
                    {isModalOpen === "add" ? "Add Skill" : "Edit Skill"}
                  </h4>
                </div>

                <div className="d-flex justify-content-end">
                  <i
                    className="fa-solid fa-xmark cursor text-muted"
                    onClick={closeModal}
                  ></i>
                </div>
              </div>
            </CardHeader>

            <Form onSubmit={(e) => e.preventDefault()}>
              <CardBody>
                <Row>
                  <Col md="6" className="mb-3">
                    <FormGroup>
                      <Label>
                        Skill Name <span className="text-danger">*</span>
                      </Label>
                      <Input
                        name="skillName"
                        type="text"
                        placeholder="Enter skills"
                        value={formData.skillName.value}
                        onChange={(e) =>
                          handleInputChange(e.target.name, e.target.value)
                        }
                        onBlur={(e) =>
                          handleOnBlur(e.target.name, e.target.value)
                        }
                        className={formData.skillName.error ? "is-invalid" : ""}
                      />
                      {formData.skillName.error && (
                        <small className="text-danger">
                          {formData.skillName.error}
                        </small>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md="6" className="mb-3">
                    <FormGroup>
                      <Label>
                        Status <span className="text-danger">*</span>
                      </Label>
                      <div className="radio-rapper">
                        <FormGroup check inline>
                          <Label check>
                            <Input
                              type="radio"
                              name="status"
                              value="ACTIVE"
                              className="cursor"
                              checked={formData.status.value === "ACTIVE"}
                              onChange={(e) =>
                                handleInputChange("status", e.target.value)
                              }
                            />{" "}
                            Active
                          </Label>
                        </FormGroup>
                        <FormGroup check inline>
                          <Label check>
                            <Input
                              type="radio"
                              name="status"
                              value="INACTIVE"
                              className="cursor"
                              checked={formData.status.value === "INACTIVE"}
                              onChange={(e) =>
                                handleInputChange("status", e.target.value)
                              }
                            />{" "}
                            Inactive
                          </Label>
                        </FormGroup>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>

              <CardFooter className="text-right">
                <Button color="secondary" onClick={closeModal}>
                  Cancel
                </Button>
                <Button color="deep-blue" onClick={handleSubmit}>
                  Save
                </Button>
              </CardFooter>
            </Form>
          </Card>
        </RightPanelCard>
      </Container>
    </>
  );
}

export default Skills;
